import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router"
import { MsalService } from '@azure/msal-angular';
//import { MsalService, BroadcastService, MsalModule } from '@azure/msal-angular';
@Component({
  selector: 'app-logged-out',
  templateUrl: './logged-out.component.html',
  styleUrls: ['./logged-out.component.css']
})
export class LoggedOutComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: MsalService,
  ) { }

  ngOnInit() {
    this.authService.handleRedirectCallback((authError, response) => {
      if (authError) {
        console.error('Redirect Error: ', authError.errorMessage);
        return;
      }
      console.log('Redirect Success: ', response.accessToken);
    });

  }

  logIn() {
    this.router.navigate(['/signin/sso'], { relativeTo: this.route }).then(nav => {
    }, err => {
      console.log("Error: " + err)
    })
  }

  ngOnDestroy() {
  }
}
